import { Component, inject, signal } from '@angular/core';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'cad-ad-name',
  imports: [ReactiveFormsModule],
  templateUrl: './ad-name.html',
  styleUrl: './ad-name.css',
})
export class AdName {

  expanded = signal<boolean>(true);

  private createSparkCampaignService = inject(CreateSparkCampaign);

  readonly adNameControl = new FormControl<string>('', { nonNullable: true });

  constructor() {
    const initial = this.createSparkCampaignService.adName();
    this.adNameControl.setValue(initial ?? '', { emitEvent: false });
    this.adNameControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((value) => {
      const trimmed = value.trim();
      this.createSparkCampaignService.adName.set(trimmed.length > 0 ? trimmed : undefined);
    });
  }
}
